export const teams = {
  'FC Barcelona Femení': {
    id: '20091',
    catergory: 'soccer',
    division: [
      'ESP.W.1',
      'UEFA.WCHAMPIONS',
      'ESP.COPA_DE_LA_REINA',
      'GLOBAL.WCHAMPS_CUP',
    ],
  },
  'Arsenal W.F.C': {
    id: '19973',
    catergory: 'soccer',
    division: ['ENG.W.FA', 'UEFA.WCHAMPIONS', 'ENG.W.1'],
  },
  CHINA: {
    id: '2754',
    catergory: 'soccer',
    division: [
      'FIFA.FRIENDLY.W',
      'FIFA.WWC',
      'FIFA.W.OLYMPICS',
      'FIFA.W.ALGARVE',
    ],
  },
  'Toronto Maple Leafs': {
    id: '21',
    catergory: 'hockey',
    division: ['nhl'],
  },
  'BAYERN MUNICH': {
    id: '132',
    catergory: 'soccer',
    division: ['UEFA.CHAMPIONS', 'GER.1', 'GER.DFB_POKAL'],
  },
};
